import * as React from 'react';
import { Divider } from 'antd';
import type { DynamicComponentProps } from '@/types/commontypes';
import styles from '../../../styles/global.module.css';

const AntSeparator: React.FC<DynamicComponentProps<string>> = ({ label }) => {
  return (
    <div
      className={`text-[11px] ${styles.divider}`}
      style={{
        gridColumn: 'span 2',
      }}
    >
      <Divider
        titlePlacement="center"
        size="small"
        style={{
          borderColor: 'var(--borderColor, rgb(196, 198, 192))',
          fontWeight: '600',
          fontSize: '14px',
        }}
      >
        {label}
      </Divider>
    </div>
  );
};

export default AntSeparator;
